// extracted by mini-css-extract-plugin
export default {"button":"buttonDisible_button__VrSeY","text_input":"buttonDisible_text_input__kkxRH"};